import React from "react";

const JobOverview = ({
    completedJobs = 0,
    ongoingJobs = 0,
}) => {
    const totalJobs = completedJobs + ongoingJobs;

    const completedPercentage =
        totalJobs > 0 ? (completedJobs / totalJobs) * 100 : 0;

    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[20px] md:p-[24px] flex flex-col">
            <h3 className="font-semibold text-[16px] text-[#212326] mb-[20px]">
                Jobs Overview
            </h3>

            <div className="mb-[16px]">
                <span className="font-semibold text-[36px] text-[#212326]">
                    {totalJobs}
                </span>
                <span className="font-medium text-[14px] text-[#717182] ml-[8px]">
                    Total Jobs
                </span>
            </div>

            {/* Progress Bar */}
            <div className="w-full h-[10px] rounded-full bg-[#f4f5f6] mb-[20px] overflow-hidden">
                <div
                    className="h-full rounded-full bg-[#ff5323] transition-all duration-500"
                    style={{
                        width: `${completedPercentage}%`,
                    }}
                />
            </div>

            {/* Stats */}
            <div className="flex items-center gap-[24px] mt-auto">

                <div>
                    <div className="flex items-center gap-[6px] mb-[4px]">
                        <div className="w-[10px] h-[10px] rounded-[3px] bg-[#ff5323]" />
                        <span className="text-[12px] text-[#717182]">
                            Completed
                        </span>
                    </div>

                    <span className="font-semibold text-[18px] text-[#212326]">
                        {completedJobs}
                    </span>
                </div>

                <div>
                    <div className="flex items-center gap-[6px] mb-[4px]">
                        <div className="w-[10px] h-[10px] rounded-[3px] bg-[#f4f5f6] border border-[#e4e5e7]" />
                        <span className="text-[12px] text-[#717182]">
                            Ongoing
                        </span>
                    </div>

                    <span className="font-semibold text-[18px] text-[#212326]">
                        {ongoingJobs}
                    </span>
                </div>

            </div>
        </div>
    );
};

export default JobOverview;